const { default: Button } = require('components/shared/Button/Button');
const { default: Typography } = require('components/shared/Typography/Typography');
const { mString, cn } = require('lib/helpers/utility');
const { useState } = require('react');
const { default: SummaryItem } = require('./SummaryItem');
const { default: Switch } = require('components/shared/Switch/Switch');

const TaxesAndFees = ({
  preview,
  onTechnologyFeeToggle,
  isSurchargeApplied,
  technologyFee,
  // stateTax, // Temporarily commented out as per recent changes
  // localTax, // Temporarily commented out as per recent changes
  tax
}) => {
  const [open, setOpen] = useState(preview);
  return (
    <div className="flex flex-col gap-5 pl-2 sm:gap-2">
      <div className="flex w-full items-center justify-between">
        <Button
          variant="link"
          text="Taxes and Fees"
          color="neutral"
          size="xs"
          iconColor="neutral-700"
          iconRight={!preview && 'chevron-down-linear'}
          iconClassName={cn('transition-transform duration-300', open && 'rotate-180')}
          shade={600}
          textClassName="text-sm leading-[114%] font-medium none text-neutral-600"
          isDisabled={preview}
          onClick={() => setOpen((prev) => !prev)}
          className={cn(preview && 'cursor-default')}
        />
        <Typography variant="label" size="medium">
          {mString(tax + technologyFee)}
        </Typography>
      </div>
      <div
        className={cn(
          'flex w-full flex-col gap-5 overflow-hidden pl-6 transition-all duration-300 sm:gap-2 sm:pl-2',
          open ? 'max-h-40 opacity-100' : 'pointer-events-none mt-0 max-h-0 opacity-0'
        )}
        style={{ transitionProperty: 'max-height, opacity' }}
        aria-hidden={!open}>
        <SummaryItem label="Local and state tax" value={tax} />
        {/* <SummaryItem label="Local tax" value={localTax} /> */}
        <div className="flex w-full items-center justify-between">
          <div className="flex items-center gap-2 pl-2">
            <Typography variant="label" size="medium" weight="medium" color="neutral-600">
              Technology fee
            </Typography>
            {!preview && <Switch onChange={onTechnologyFeeToggle} checked={isSurchargeApplied} />}
          </div>
          <Typography variant="label" size="medium">
            {mString(technologyFee)}
          </Typography>
        </div>
      </div>
    </div>
  );
};

export default TaxesAndFees;
